"use client"
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string
    pop?: boolean
}

export function Checkbox(props: CheckboxProps) {
    const { label, pop, ...rest } = props
    const [animate, setAnimate] = useState(false)
    const [isFirstRender, setIsFirstRender] = useState(true)
    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRender(false);
            return;
        }
        setAnimate(true);
        const timer = setTimeout(() => {
            setAnimate(false);
        }, 1000);
    
        return () => clearTimeout(timer); 
    }, [pop]); //eslint-disable-line react-hooks/exhaustive-deps
    return (
        <label className="flex items-center cursor-pointer">
            <input
                {...rest}
                type="checkbox"
                className="peer hidden"
            />
            <span className={cn("w-[18px] h-[18px] flex items-center justify-center border-2 border-gray-300 rounded-md peer-checked:bg-primary peer-checked:border-primary transition-colors duration-300", )}>
                {props.checked && (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-3 h-3 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={4}
                            d="M5 13l4 4L19 7"
                        />
                    </svg>
                )}
                {animate && (
                    <span className={cn("w-full h-full rounded-md border-3 border-primary",{"animate-pop": animate})}/>
                )}
            </span>
            <span className="ml-2 text-xs">{label}</span>
        </label>
    );
}